<template>
<div>
    <div class="page-body">
        <div class="tbs">

            <el-table :data="listData" v-loading="false" style="width: 100%" border>
                <el-table-column label="姓名" prop="name"> </el-table-column>
                <el-table-column label="关联账号" prop="account" width="220">
                </el-table-column>
                <el-table-column label="状态" width="90">
                    <template slot-scope="scope">
                        {{ scope.row.status | filterStatus() }}
                    </template>
                </el-table-column>
                <el-table-column align="left" width="180" label="操作">
                    <template slot-scope="scope">
                        <el-button type="warning" @click="goEdit(scope.row)" size="mini">编辑</el-button>
                        <el-button type="danger" @click="deleteDTO(scope.row.id)" size="mini">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination @current-change="handleCurrentChange" :current-page.sync="params.basePage.no" :page-size="params.basePage.size" layout="total, prev, pager, next" :total="totalElements" :background="false" :hide-on-single-page="true">
                </el-pagination>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    getLawyerListByCondition,
    delLawyer,
} from '@/api/jingshi';
export default {
    components: {},
    data() {
        return {
            loading: false,
            listData: [],
            totalElements: 0, //总条数
            params: {
                name: '', // 关键词
                status: 0, // 1启用、2禁用
                basePage: {
                    size: 12, // 分页大小
                    no: 1, // 当前分页
                }
            }
        }
    },
    filters: {
        filterStatus: function (e) {
            var transMap = {
                0: '未知',
                1: '启用',
                2: '禁用',
            };
            return transMap[e];
        }
    },
    methods: {
        search(params) {
            if (params) {
                for (let key in this.params) {
                    if (params.hasOwnProperty(key)) {
                        this.params[key] = params[key];
                    }
                }
            }
            this.getList();
        },
        // 获取文章列表
        getList() {
            var vues = this;
            this.loading = true;
            getLawyerListByCondition(this.params).then(res => {
                this.listData = res.lawyerLists
                console.log(res);
                vues.loading = false;
                this.totalElements = res.totalElements;
                // vues.showArr = res.cmsColumnLists;
                // console.log(vues.showArr);
            })
        },
        // 删除文章列表
        deleteDTO(id) {
            var param = {
                ids: [id]
            }
            delLawyer(param).then(res => {
                this.$message.success('操作成功!')
                this.getList()
            }).catch(err => {
                console.log(err);
            })
        },
        // 编辑 
        goEdit: function (e) { // 编辑
            var querys = {};
            querys.id = e.id;
            querys.type = 2;
            this.$router.push({
                path: 'add_lawyer_library',
                query: querys
            });
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            this.params.basePage.no = val;
            this.getList();
        },
    },
    created: function () {
        this.getList()
    }
}
</script>

<style lang="scss">
.page-body {
    padding: 20px;
}

.page-body table {
    width: 100%;
}

// 头部样式
.page-body th {
    background-color: #efefef;
}

.tbs {

    .pagination {
        background: white;
        text-align: center;
        margin: 0 0px 0 0px;
    }
}
</style>



// WEBPACK FOOTER //
// list.vue?04b22a97